<template>
  <div>
    <div v-if="user" class="mb-4">
      <Link class="group flex items-center py-3 mb-4" href="/">
        <icon class="w-5 h-5 mr-2" name="fox" :class="isUrl('') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-secondary'"/>
        <div :class="isUrl('') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('general.home') }}</div>
      </Link>

      <Link class="group flex items-center py-3 mb-4" href="/themenbezogenes-lernen">
        <icon class="w-5 h-5 mr-2" name="themen" :class="isUrl('themenbezogenes-lernen') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-primary'"/>
        <div :class="isUrl('themenbezogenes-lernen') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('categories.menu') }}</div>
      </Link>

      <Link class="group flex items-center py-3 mb-4" href="/pruefungen">
        <i class="fa fa-user-graduate mr-2" :class="isUrl('pruefungen') ? 'text-orange-500 fill-orange-500' : 'text-primary-500 fill-primary-500 group-hover:fill-primary'"></i>
        <div :class="isUrl('pruefungen') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('exam.plural') }}</div>
      </Link>

      <Link class="group flex items-center py-3 mb-4" href="/meine-pruefungen">
        <icon class="w-5 h-5 mr-2" name="continue" :class="isUrl('meine-pruefungen') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-primary'"></icon>
        <div :class="isUrl('meine-pruefungen') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('test.index') }}</div>
      </Link>

      <Link class="group flex items-center py-3 mb-4" href="/meine-fehler">
        <icon class="w-5 h-5 mr-2" name="redo" :class="isUrl('meine-fehler') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-primary'" />
        <div :class="isUrl('meine-fehler') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('mistakes.index') }}</div>
      </Link>
    </div>

    <div class="mb-4">
      <Link class="group flex items-center py-3 mb-4" href="/info">
        <icon class="w-5 h-5 mr-2" name="info" :class="isUrl('info') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-primary'" />
        <div :class="isUrl('info') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('general.info') }}</div>
      </Link>
    </div>

    <div v-if="!user" class="mb-4">
      <Link class="group flex items-center py-3 mb-4" href="/login">
        <i class="fa fa-sign-in mr-2" :class="isUrl('login') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-secondary'"></i>
        <div :class="isUrl('') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('general.login') }}</div>
      </Link>
    </div>

    <div v-if="user && user.isAdmin" class="">
      <hr>
      <h4 class="block uppercase text-gray-400 font-semibold my-4">{{ __('general.admin') }}</h4>

      <Link class="group flex items-center py-3 mb-4" href="/users">
        <icon class="w-5 h-5 mr-2" name="users" :class="isUrl('users') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-primary'" />
        <div :class="isUrl('contacts') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('user.plural') }}</div>
      </Link>

      <Link class="group flex items-center py-3 mb-4" href="/admin/exam">
        <icon class="w-5 h-5 mr-2" name="printer" :class="isUrl('admin/exam') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-primary'" />
        <div :class="isUrl('admin/exam') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('test.plural') }}</div>
      </Link>

      <Link v-if="false" class="group flex items-center py-3 mb-4" href="/admin/questions">
        <icon class="w-5 h-5 mr-2" name="info" :class="isUrl('admin/questions') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-primary'" />
        <div :class="isUrl('admin/questions') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('test.plural') }}</div>
      </Link>

      <Link class="group flex items-center py-3 mb-4" href="/admin/info">
        <icon class="w-5 h-5 mr-2" name="info" :class="isUrl('admin/info') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-primary'" />
        <div :class="isUrl('admin/info') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('admin.edit_info') }}</div>
      </Link>

      <Link class="group flex items-center py-3 mb-4" href="/admin/settings">
        <icon class="w-5 h-5 mr-2" name="gear" :class="isUrl('admin/settings') ? 'text-orange-500 fill-orange-500' : 'fill-primary-500 group-hover:fill-primary'" />
        <div :class="isUrl('admin/settings') ? 'text-secondary' : 'text-secondary-300 group-hover:text-secondary'">{{ __('admin.settings') }}</div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Icon,
    Link,
  },

  props: {
    auth: Object,
  },

  data() {
    return {
      user: null,
    }
  },

  mounted() {

    if( usePage().props.value.auth.user ) {
      this.user = usePage().props.value.auth.user
    }

  },

  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
